import { shouldDisplayWarning as shouldDisplayWarningFn } from 'containers/CommentDetails/lib/http';
import _ from 'lodash';
import * as React from 'react'
import { Alert, Card, Col, Nav, NavItem, NavLink, Row } from 'reactstrap';
import { LazyTabPane } from '../../components/LazyTabPane';
import { ContentCardHeader } from '../../components/ui/ContentCardHeader';
import { FontAwesomeIcon } from '../../components/ui/FontAwesomeIcon';
import { userData } from '../../util/userData';
import { CommentCodeEditor } from './lib/CommentCodeEditor';
import { CommentCodesAuditLogGrid } from './lib/CommentCodesAuditLogGrid';
import { CommentCodesGrid } from './lib/CommentCodesGrid';

interface ICommentCodesContainerState {
  activeTab: string
  currentProject: string
  isGlobalCodes?: boolean
  shouldDisplayWarning?: boolean
}

export class CommentCodesContainer extends React.Component<{}, ICommentCodesContainerState> {
  tabs = {
    CommentCodes: 'Edit Codes',
    ArchivedCommentCodes: 'Archived Codes',
    AuditLogs: 'Audit Logs',
    AddCommentCode: 'Add Code'
  }

  state: ICommentCodesContainerState = {
    activeTab: this.tabs.CommentCodes,
    currentProject: '',
    shouldDisplayWarning: false,
  }

  contentElement: HTMLElement

  componentWillMount() {
    userData.getToken().then((token) => {
      const currentProject = userData.getCurrentProject()
      const isGlobalCodes = currentProject === 'ABCU'

      this.setState({ isGlobalCodes, currentProject })
    })

    shouldDisplayWarningFn().then((response) => {
      this.setState({ shouldDisplayWarning: (response.hasPermission === 1) })
    })
  }

  setActiveTab(activeTab: string) {
    if (this.contentElement) {
      this.contentElement.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' })
    }

    this.setState({ activeTab })
  }

  renderGlobalWarning() {
    const { isGlobalCodes, currentProject, shouldDisplayWarning } = this.state

    if (typeof isGlobalCodes === 'undefined' || (!shouldDisplayWarning)) { return; }

    const color = isGlobalCodes ? 'danger' : 'warning'
    const alertClassNames = ['h5', 'shadow-sm']
    let warningText: React.ReactChild = ''

    if (isGlobalCodes) {
      //alertClassNames.push('border-danger');
      warningText = (
        <span>You are currently editing comment codes that are used globally for all clients.</span>
      )
    } else {
      //alertClassNames.push('border-warning');
      warningText = (
        <span>
          <span>You are currently editing comment codes for {currentProject}.</span>
          <span>&nbsp;If you would like to edit global comment codes&nbsp;</span>
          <a href="javascript:void(0)" onClick={() => window.changeProject('ABCU')}>click here.</a>
        </span>
      )
    }

    return (
      <Alert color={color} className={alertClassNames.join(' ')}>
        <FontAwesomeIcon icon="exclamation-triangle" verticalAlign="initial" size="md" />
        <span>&nbsp;{warningText}</span>
      </Alert>
    )
  }

  renderNoCodeMessage(activeTab: string) {
    const { isGlobalCodes } = this.state
    let msg = ''
    let url = null
    let secondPart = ''
    if (activeTab === 'Add Code') {
      msg = 'Important Note: You currently have access to all the standard comment codes defined by Avannis. To avoid creating duplicate or similar codes, we recommend you review the list of Avannis codes before adding additional codes. To see the list of Avannis codes, click '
      url = <a href='commentdetails'>here.</a>
      secondPart = ' Go to the comment details page and view the “Comment Type” drop-down menu.'
    }

    if (activeTab === 'Edit Codes') {
      msg = 'THIS PAGE ONLY LISTS CUSTOM COMMENT CODES DEFINED FOR YOUR ORGANIZATION. If your organization has not yet defined any custom comment codes, you can begin adding custom comment codes by clicking “ADD CODE” to the left.'
    }

    if (activeTab === 'Archived Codes' || activeTab === 'Audit Logs' || isGlobalCodes) {
      return;
    }

    return (
      <section>
        <Alert color={'info'}>
          {msg}{url}{secondPart}
        </Alert>
      </section>
    )
  }

  render() {
    const { activeTab, isGlobalCodes } = this.state
    let addCommentCodeHeader = 'Add Comment Code'

    if (isGlobalCodes) {
      addCommentCodeHeader = 'Add Global Comment Code'
    }

    return (
      <section className="blacklight page-container">
        <section className="containerv2">
          <Row>
            <Col md={4} lg={3} xl={2}>
              <Nav pills className="flex-column sticky-top-md-1 mb-4">
                {_.values(this.tabs).map((tab) =>
                  <NavItem key={tab}>
                    <NavLink
                      href="javascript:void(0)"
                      active={activeTab === tab}
                      onClick={() => this.setActiveTab(tab)}>
                      <h5 className="mb-0">{tab}</h5>
                    </NavLink>
                  </NavItem>
                )}
              </Nav>
            </Col>
            <Col>
              {this.renderGlobalWarning()}
              {this.renderNoCodeMessage(activeTab)}
              <section ref={(contentElement) => this.contentElement = contentElement}>
                <LazyTabPane activeTab={activeTab} tabId={this.tabs.CommentCodes} className="subtleSlideInRight">
                  <CommentCodesGrid isGlobal={isGlobalCodes} />
                </LazyTabPane>
                <LazyTabPane activeTab={activeTab} tabId={this.tabs.ArchivedCommentCodes} className="subtleSlideInRight">
                  <CommentCodesGrid isGlobal={isGlobalCodes} onlyArchived />
                </LazyTabPane>
                <LazyTabPane activeTab={activeTab} tabId={this.tabs.AuditLogs} className="subtleSlideInRight">
                  <CommentCodesAuditLogGrid />
                </LazyTabPane>
                <LazyTabPane activeTab={activeTab} tabId={this.tabs.AddCommentCode} className="subtleSlideInRight">
                  <Card>
                    <ContentCardHeader header={addCommentCodeHeader} sticky borderBottom />
                    <CommentCodeEditor onSuccess={() => this.setActiveTab(this.tabs.CommentCodes)} />
                  </Card>
                </LazyTabPane>
              </section>
            </Col>
          </Row>
        </section>
      </section>
    )
  }
}
